var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListSuppliesOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.91667 2C9.91667 1.58579 10.2525 1.25 10.6667 1.25H14C14.4142 1.25 14.75 1.58579 14.75 2V5.33251C14.75 5.74673 14.4142 6.08251 14 6.08251C13.5858 6.08251 13.25 5.74673 13.25 5.33251V3.81035L9.8636 7.19591C9.57067 7.48877 9.09579 7.48871 8.80294 7.19578C8.51008 6.90285 8.51014 6.42798 8.80307 6.13512L12.189 2.75H10.6667C10.2525 2.75 9.91667 2.41421 9.91667 2ZM3.33333 4.08301C3.01088 4.08301 2.75 4.34389 2.75 4.66634V12.6663C2.75 12.9888 3.01088 13.2497 3.33333 13.2497H11.3333C11.6558 13.2497 11.9167 12.9888 11.9167 12.6663V9.33301C11.9167 8.91879 12.2525 8.58301 12.6667 8.58301C13.0809 8.58301 13.4167 8.91879 13.4167 9.33301V12.6663C13.4167 13.8172 12.4842 14.7497 11.3333 14.7497H3.33333C2.18245 14.7497 1.25 13.8172 1.25 12.6663V4.66634C1.25 3.51546 2.18245 2.58301 3.33333 2.58301H6.66667C7.08088 2.58301 7.41667 2.91879 7.41667 3.33301C7.41667 3.74722 7.08088 4.08301 6.66667 4.08301H3.33333Z",
    fill: "#323232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListSuppliesOpen);
export default __webpack_public_path__ + "static/media/listSuppliesOpen.5bc408c9b209402ee72f81928384b164.svg";
export { ForwardRef as ReactComponent };